import { Jodit } from 'jodit'
import { feedbackMessengerWindowWysiwygSelector } from './feedback-messenger-window-wysiwyg.selectors'

const buttons = [
	'source',
	'|',
	'bold',
	'italic',
	'|',
	'ul',
	'ol',
	'eraser',
	'|',
	'font',
	'fontsize',
	'brush',
	'paragraph',
	'|',
	'image',
	'table',
	'link',
	'|',
	'align',
	'\n',
	'undo',
	'redo',
	'|',
	'hr',
	'copyformat',
	'fullsize',
]

export const FeedbackMessengerWindowWysiwyg = (() => {
	const initWysiwyg = () => {
		const feedbackMessengerWindowWysiwygElement =
			feedbackMessengerWindowWysiwygSelector.getFeedbackMessengerWindowWysiwyg()

		if (feedbackMessengerWindowWysiwygElement === null) {
			return
		}

		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		const wysiwygInstance = new Jodit(feedbackMessengerWindowWysiwygElement, {
			cleanHTML: {
				removeEmptyElements: false,
			},
			enter: 'br',
			toolbarButtonSize: 'small',
			showCharsCounter: false,
			toolbarSticky: false,
			showWordsCounter: false,
			showXPathInStatusbar: false,
			buttons: [...buttons],
			toolbarAdaptive: false,
			uploader: {
				insertImageAsBase64URI: true,
			},
		})
	}

	const initHandlers = () => {
		initWysiwyg()
	}

	const init = () => {
		initHandlers()
	}

	return {
		init,
	}
})()
